import PropTypes from 'prop-types';
import DatasourceBaseOauthNew from "../Datasources/DatasourceBaseOauthNew.jsx";

const DatasourceIntelliflo = (props) => {

    const ClientId = "app-616d663-acf-f4437f91c15e4304b8bcd5b867abc4b9"
    const Scope = "openid offline_access myprofile client_data firm_data"
    const RedirectUrl = "https://auth.cloudcti.nl/webapi/oauth2"
    const AuthUrl = "https://identity.gb.intelliflo.net/core/connect/authorize?scope=" + Scope + "&client_id=" + ClientId + "&response_type=code&redirect_uri=" + RedirectUrl

    return <DatasourceBaseOauthNew SecurityToken={props.SecurityToken} DatasourceData={props.DatasourceData} IntegrationSettings={props.IntegrationSettings} AuthUrl={AuthUrl} CrmServerTokenController="/api/intelliflo/tokens" OnSetReady={props.OnSetReady}/>
}

DatasourceIntelliflo.propTypes = {
    SecurityToken: PropTypes.string,
    DatasourceData: PropTypes.object,
    IntegrationSettings: PropTypes.object,
    OnSetReady: PropTypes.func
}   

export default DatasourceIntelliflo